/* English direct links remain readable; subsequent storefront navigation is Georgian. */
(function () {
  'use strict';
  if (!/^\/en(?:\/|$)/.test(window.location.pathname)) return;

  function primaryUrl(value) {
    if (!value || value.charAt(0) === '#') return value;
    var url;
    try { url = new URL(value, window.location.href); } catch (_) { return value; }
    if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return value;
    if (!/^\/en(?:\/|$)/.test(url.pathname)) return value;
    url.pathname = url.pathname.replace(/^\/en(?=\/|$)/, '') || '/';
    return url.pathname + url.search + url.hash;
  }

  function updateLink(link) {
    var href = link.getAttribute('href');
    var localized = primaryUrl(href);
    if (localized !== href) link.setAttribute('href', localized);
  }

  document.querySelectorAll('a[href]').forEach(updateLink);
  // Capture dynamic search/cart links, keyboard activation and middle clicks too.
  ['click', 'auxclick', 'contextmenu'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (link) updateLink(link);
    }, true);
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var action = form.getAttribute('action');
    var localized = primaryUrl(action);
    if (localized !== action) form.setAttribute('action', localized);
  }, true);
})();
